import { RequestJson } from '@helpers/fetch-json';
import AppDataContext from '@stores/app-data-context';
import PageActionContext from '@stores/page-action-context';
import FormHtmlInput from '@ui/forms/form-input';
import useForm, { buildInput } from '@ui/forms/use-form';
import React, { useContext, useEffect, useState } from 'react';

const FormPreEnquiryPersonalDetails = ({ data }) => {
    const { displayScope, name, mobile, email, stockId, nextUrl, isExternal } =
        data;
    const pageActionCxt = useContext(PageActionContext);
    const appDataCxt = useContext(AppDataContext);
    const contextPersonInfo = appDataCxt.getPersonalDetails() ?? {};

    const getCurrentDimension = () => {
        return {
            width: window.innerWidth,
            height: window.innerHeight,
        };
    };

    const [screenSize, setScreenSize] = useState(getCurrentDimension());

    const isVisible = () => {
        const mdWidth = 768;
        if (displayScope === 'Small') {
            if (screenSize.width < mdWidth) {
                return true;
            }
        } else {
            if (screenSize.width >= mdWidth) {
                return true;
            }
        }
        return false;
    };

    const inputs = [
        buildInput(name, contextPersonInfo?.fullName),
        buildInput(mobile, contextPersonInfo?.mobile),
        buildInput(email, contextPersonInfo?.email),
    ];

    const form = useForm({
        inputs: inputs,
        onSubmit: (values) => {
            console.log(values);
        },
    });

    useEffect(() => {
        pageActionCxt.reset();
    }, []);

    useEffect(() => {
        pageActionCxt.setNextDisabled(!form.isValid);
    }, [form.isValid]);

    useEffect(() => {
        const updateDimension = () => {
            setScreenSize(getCurrentDimension());
        };

        window.addEventListener('resize', updateDimension);

        return () => {
            window.removeEventListener('resize', updateDimension);
        };
    }, [screenSize]);

    useEffect(() => {
        if (isVisible() && pageActionCxt.isNextClicked) {
            pageActionCxt.setNextClicked(false);

            submitForm(form);
        }
    }, [pageActionCxt.isNextClicked]);

    const submitForm = (f) => {
        if (!f.isValid) {
            return;
        }

        pageActionCxt.setNextBusy(true);
        pageActionCxt.setNextDisabled(true);

        const nextEventData = pageActionCxt.nextEventData;

        const { name, email, mobile } = f.values;

        const { firstName, middleName, lastName } = getNameParts(name);

        const loanData = appDataCxt.getLoanRequirements();
        const vehiclePrice = loanData?.vehiclePrice ?? 0;

        const request = {
            fullName: name,
            firstName: firstName,
            middleName: middleName,
            lastName: lastName,
            email: email,
            mobile: mobile,
            vehiclePrice: vehiclePrice,
        };

        RequestJson(nextEventData.url, 'POST', request)
            .then((rsp) => {
                pageActionCxt.setNextBusy(false);
                pageActionCxt.setNextDisabled(false);
                pageActionCxt.navigate(rsp.data.nextUrl, rsp.data.isExternal);
                setAppDataContext(
                    name,
                    firstName,
                    middleName,
                    lastName,
                    email,
                    mobile
                );
            })
            .catch((err) => {
                console.log(err);
                pageActionCxt.setNextBusy(false);
                pageActionCxt.setNextDisabled(false);
            });
    };

    const getNameParts = (fullName) => {
        let splitName = fullName.trim().split(/\s+/);
        let [firstName, middleName, lastName] = ['', '', ''];

        if (splitName.length > 2)
            [firstName, middleName, lastName] = [
                splitName.shift(),
                splitName.shift(),
                splitName.join(' '),
            ];
        else if (splitName.length == 2)
            [firstName, lastName] = [splitName.shift(), splitName.shift()];
        else firstName = splitName.shift();

        return { firstName, middleName, lastName };
    };

    const setAppDataContext = (
        fullName,
        firstName,
        middleName,
        lastName,
        email,
        mobile
    ) => {
        const loanRequirements = appDataCxt.getLoanRequirements();

        appDataCxt.setLoanRequirementsAndPersonDetails(
            {
                ...loanRequirements,
                stockId: stockId,
            },
            {
                ...contextPersonInfo,
                fullName: fullName,
                email: email,
                mobile: mobile,
                firstName: firstName,
                middleName: middleName,
                lastName: lastName,
            }
        );
    };

    return (
        <form className="flex flex-col gap-6 w-full">
            <FormHtmlInput data={name} form={form} />
            <FormHtmlInput data={email} form={form} />
            <FormHtmlInput data={mobile} form={form} />
        </form>
    );
};

export default FormPreEnquiryPersonalDetails;
